/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJobTable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 8h6V2h-6zm4-4v2h-2V4zm-4 11h6V9h-6zm4-4v2h-2v-2zm-5 4H9V9h6zm-2-2v-2h-2v2zm3 9h6v-6h-6zm4-4v2h-2v-2zm-5 4H9v-6h6zm-2-2v-2h-2v2zM2 22h6v-6H2zm4-4v2H4v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgJobTable as JobTable };
